import Route from '@ember/routing/route';
import { service } from '@ember/service';
// This is for types. Anything we have custom may show an error.
import type StoreService from 'ember-data/store';

export default class AuthenticatedAdminTuitionAssistanceProgramTemplatesShowRoute extends Route {
  @service declare store: StoreService;

  includes = ['company.company-setting', 'conditions.public-assets'];

  model(params: { tas_program_template_id: string }) {
    return this.store.findRecord('tas-program-template', params.tas_program_template_id, {
      reload: true,
      include: this.includes.join(','),
    });
  }
}
